export class JobDescriptionKeys {
    public job_titles: string[];
    public mandatory_job_titles: string[];
    public skills: string[];
    public mandatory_skills: string[];
    public schools: string[];
    public mandatory_schools: string[];
    public locations: string[];
    public mandatory_locations: string[];
    public company_sizes: string[];
    public mandatory_company_sizes: string[];
    public companies: string[];
    public mandatory_companies: string[];
    public industries: string[];
    public mandatory_industries: string[];
    public degrees: string[];
    public mandatory_degrees: string[];
    public education_majors: string[];
    public mandatory_education_majors: string[];
    public fromYrsOfExperience: number;
    public toYrsOfExperience: number;

    constructor() {
        this.job_titles = [];
        this.mandatory_job_titles = [];
        this.skills = [];
        this.mandatory_skills = [];
        this.schools = [];
        this.mandatory_schools = [];
        this.locations = [];
        this.mandatory_locations = [];
        this.company_sizes = [];
        this.mandatory_company_sizes = [];
        this.companies = [];
        this.mandatory_companies = [];
        this.industries = [];
        this.mandatory_industries = [];
        this.degrees = [];
        this.mandatory_degrees = [];
        this.education_majors = [];
        this.mandatory_education_majors = [];
        this.fromYrsOfExperience = null;
        this.toYrsOfExperience = null;
    }
}
